import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const HowItWorksRoot = styled('div', {
  padding: '$6 $2',

  variants: {
    variant: {
      primary: {
        background: '$secondary-500',
      },
      secondary: {
        background: '$tertiary-200',
      },
    },
  },
})

export const Title = styled('h2', {
  fontSize: '$h3',
  lineHeight: '$h3',
  marginBottom: '$2',
  textAlign: 'center',

  '@bp2': {
    fontSize: '$h1',
    lineHeight: '$h1',
    marginBottom: '$5',
  },

  variants: {
    variant: {
      primary: {
        color: '$accent-white',
      },
      secondary: {
        color: '$accent-black',
      },
    },
  },
})

export const HowItWorksContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

export const StepWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0px',
  width: '100%',
  maxWidth: '340px',
  color: '$accent-white',

  '@bp2': {
    gap: '0px',
    width: '240px',
    maxWidth: 'none',
    color: '$accent-black',
  },

  '@bp3': {
    width: '290px',
  },
})

export const StepImage = styled('div', {
  position: 'relative',
  lineHeight: 0,
  display: 'none',

  '& img': {
    borderRadius: '4px 4px 0 0',
  },

  '@bp2': {
    display: 'block',
  },
})

export const StepCopy = styled('div', {
  padding: '$2',
  background: 'none',
  height: 'auto',
  borderRadius: '0 0 4px 4px',
  display: 'flex',
  flexDirection: 'row',
  textAlign: 'left',
  alignItems: 'flex-start',
  
  '@bp2': {
    background: '$accent-white',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    height: '220px',
  },

  '@bp3': {
    height: '200px',
  },

  variants: {
    variant: {
      primary: {
        color: '$accent-white',
        '@bp2': {
          background: '$accent-white',
          color: '$accent-black',
        },
      },
      secondary: {
        color: '$accent-black',
        '@bp2': {
          background: '$tertiary-200',
        },
      },
    },
  },
})

export const Number = styled('h3', {
  marginBottom: '$2',
  width: 'auto',
  fontSize: '$h1',
  lineHeight: '$h1',
  marginRight: '$2',

  '@bp2': {
    width: '100%',
    fontSize: '$h3',
    lineHeight: '$h3',
    marginRight: '0',
  },
})
export const Action = styled(Text, {
  marginBottom: '$1',
})
export const Description = styled(Text, {})
export const StepsContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: '0',

  '@bp2': {
    flexDirection: 'row',
    gap: '$4',
  },

  '@bp3': {
    gap: '$8',
  },
})

export const ButtonWrapper = styled('div', {
  display: 'none',

  '@bp2': {
    marginTop: '$8',
    display: 'block',
  },
})
